import React from 'react';
import { withStyles } from '@mui/styles';
import Numeral from 'numeral';
import { moneyFormat } from '../../../utils/appUtils';

export const FakeBar = withStyles(({ palette, config }) => ({
  barContainer: {
    width: '100%',
    height: (props) => props.height || '1rem',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1,
    background: (props) => props.barbackground || palette.graphs.line,
  },

  bar: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    right: '100%',
    transform: 'translateX(0)',
    transition: 'transform 300ms ease-in',
    background: (props) => props.barcolor || palette.common.darkGreen,
  },
  number: {
    color: config.colors.white,
    fontSize: config.textSizes.petite,
    fontWeight: 600,
    marginLeft: '100%',
    position: 'relative',
    top: -1,
    fontFamily: config.fonts.stackSans,
    fontStyle: 'italic',
  },
}))(
  ({
    // @ts-expect-error TS(2339): Property 'classes' does not exist on type 'Consist... Remove this comment to see the full error message
    classes,
    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Consi... Remove this comment to see the full error message
    className,
    // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Consisten... Remove this comment to see the full error message
    value = 0,
    // @ts-expect-error TS(2339): Property 'aggregate' does not exist on type 'Consi... Remove this comment to see the full error message
    aggregate,
    // @ts-expect-error TS(2339): Property 'percentage' does not exist on type 'Cons... Remove this comment to see the full error message
    percentage,
    // @ts-expect-error TS(2339): Property 'formatLabel' does not exist on type 'Con... Remove this comment to see the full error message
    formatLabel = formatLimit,
  }) => {
    const barStyles = {
      transform: `translateX(${value}%)`,
    };

    const barLabel = formatLabel(percentage * aggregate);

    return (
      <div className={`${classes.barContainer} ${className}`}>
        <div className={classes.bar} style={barStyles}>
          <span className={classes.number}>
            {barLabel === '$0' || barLabel === '0' ? null : barLabel}
          </span>
        </div>
        {percentage === 1 && (
          <span className={classes.number} style={{ marginLeft: '85%' }}>
            {barLabel}
          </span>
        )}
      </div>
    );
  }
);

function formatLimit(raw: any) {
  return Number.isInteger(raw / 1000)
    ? Numeral(raw).format('0,0a')
    : moneyFormat(raw);
}
